export function setRem(baseWidth) {
    if (baseWidth === void 0) { baseWidth = 375; }
    var dpr = window.devicePixelRatio;
    var currentWidth = document.documentElement.clientWidth;
    var remSize = 0;
    var scale = 0;
    scale = currentWidth / baseWidth;
    remSize = baseWidth / 10;
    remSize = remSize * scale;
    document.documentElement.style.fontSize = "".concat(remSize, "px");
    document.documentElement.setAttribute('data-dpr', "".concat(dpr));
}
